// 这里面文件导入顺序决定样式的覆盖
import Vue from 'vue'
import router from './router'
import $ from './assets/jquery-vendor.js'
import axios from 'axios'
Vue.prototype.$axios = axios
import store from '@/store'

import './assets/libs/jquery.cxslide.min.js'
import ElementUI from 'element-ui'
Vue.use(ElementUI)

// import './assets/wza/js/soundmanager'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/fonts/iconfont.css'

import animated from 'animate.css'
Vue.use(animated)

import Loading from '@/components/loading.js'
Vue.use(Loading)

import App from './App'

import ECharts from 'vue-echarts/components/ECharts'
Vue.component('chart', ECharts)

// 引入mqtt
import './mq'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

export{
  Vue
}



// WEBPACK FOOTER //
// ./src/main.js